import React from 'react';
import { Link } from "gatsby"
import Logo from '../Logo/Logo';

export const LogoCenter = (props) => {
    return(
        <Logo style={{display:'block', textAlign:'center'}} />
    );
}
export default LogoCenter;